import { taskStore } from 'stores'

class SchedulerService {
  subscribe = async () => {
    try {
      await Promise.all(taskStore.tasks.map((task) => task()))
    } catch (e) {
      console.error(e)
    }
  }

  unsubscribe = () => {
    taskStore.clear()
  }
}

export const schedulerService = new SchedulerService()
